import { registrationConstants, workflowConstants, userConstants, newLoanConstants } from "../_constants";
import { history } from "../_helpers";
import {registrationService, metadataService, ServiceUtil, workflowService, userService, SessionService, ProfileApi, ProfileService} from "../_services";

import { newLoanActions } from "../_actions";
import {error} from "password-validator/src/constants";

export const registrationActions = {
    handleNewLoanMenuClick,
    handleExistingCustomerRequest,
    handleGetStartedInformationRequest,
    handlePersonalInformationRequest,
    handlePersonalInformationBackRequest,
    handleFinancialInformationRequest,
    handleFinancialInformationBackRequest,
    handleIdTypeAndNumberRequest,
    handleConfirmationSummaryRequest,
    handleSendEmailCodeRequest,
    handleEmailValidationResponse,
    handleNavigationToPersonalDataScreen,
    handleNavigationToIDScreen,
    handleNavigationToPasswordScreen,
    handleTextOptInRequest,
    handleTextOptOutRequest,
    handleConfirmPhoneCodeRequest,
    handleConfirmOptIn,
    handleWelcomeNextRequest,
    handleInvalidToken, 
    handleSetMarketing,
    populateRegistrationProps,
    handleFinancialInformationNextRequest,
    handleReSendEmailCodeRequest,
    handleSignUpEmailValidationBackRequest,
    guestPaymentRegistration
    //,
    //handleTextOptIn,
    //handletextValidation,
    //handleError,
    //handleValidationFail,
    //handleValidationPass
};

function handleNewLoanMenuClick() {
    return dispatch => {
        workflowService.startWorkflow(workflowConstants.NEW_LOAN_WORKFLOW, dispatch, request, failure);
    };

    function request() {
        sessionStorage.removeItem("requestSubmitted");
        return {
            type: registrationConstants.NEW_CUSTOMER_GET_STARTED_REQUEST
        };
    }

    function failure(errorString) {
        return { type: registrationConstants.NEW_EXISTING_CUSTOMER_ERROR, errorString };
    }
}

function handleExistingCustomerRequest(existingCustomer) {
    sessionStorage.setItem("existingCustomer", JSON.stringify(existingCustomer.existingCustomer));
    return dispatch => {
        if (existingCustomer.existingCustomer) {
            //dispatch(request(existingCustomer));
            //history.push("/ProfileInfo");
            workflowService.startWorkflow(workflowConstants.EXISTING_CUSTOMER_REGISTRATION_WORKFLOW, dispatch, request, failure, existingCustomer);
        }
        else {
            workflowService.startWorkflow(workflowConstants.NEW_LOAN_WORKFLOW, dispatch, newCustomerGetStartedRequest, failure);
        }
    };

    function request(existingCustomer) {
        return { type: registrationConstants.NEW_EXISTING_CUSTOMER_REQUEST, existingCustomer };
    }

    function newCustomerGetStartedRequest() {
        sessionStorage.removeItem("requestSubmitted");
        return {
            type: registrationConstants.NEW_CUSTOMER_GET_STARTED_REQUEST
        };
    }

    function failure(errorString) {
        return { type: registrationConstants.NEW_EXISTING_CUSTOMER_ERROR, errorString };
    }
}

function handleGetStartedInformationRequest(getStartedInformation) {
    return dispatch => {
        workflowService.nextStep(dispatch, request, failure, getStartedInformation);
    };

    function request(getStartedInformation) {

        var registrationInfo = SessionService.getPersonalInfo();

        let personalInformation = {};

        if (registrationInfo) {
            personalInformation = {
                ...registrationInfo,
                firstName: getStartedInformation.firstName,
                lastName: getStartedInformation.lastName,
                email: getStartedInformation.email,
                confirmEmail: getStartedInformation.email,
                mobileNumber: getStartedInformation.mobilePhone,
                alternateMobileNumber: getStartedInformation.alternateMobilePhone,
                state: getStartedInformation.state,
                socialSecurityNumber: getStartedInformation.socialSecurityNumber,
                individualTaxIdentificationNumber: getStartedInformation.individualTaxIdentificationNumber,
                requestedAmount: getStartedInformation.requestedAmount,
                preApprovalCode: getStartedInformation.preApprovalCode,
                postalCode: getStartedInformation.postalCode,
                city: getStartedInformation.city
            };
        }
        else {
            personalInformation = {
                firstName: getStartedInformation.firstName,
                lastName: getStartedInformation.lastName,
                email: getStartedInformation.email,
                confirmEmail: getStartedInformation.email,
                mobileNumber: getStartedInformation.mobilePhone,
                alternateMobileNumber: getStartedInformation.alternateMobilePhone,
                state: getStartedInformation.state,
                socialSecurityNumber: getStartedInformation.socialSecurityNumber,
                individualTaxIdentificationNumber: getStartedInformation.individualTaxIdentificationNumber,
                requestedAmount: getStartedInformation.requestedAmount,
                preApprovalCode: getStartedInformation.preApprovalCode,
                postalCode: getStartedInformation.postalCode,
                city: getStartedInformation.city
            };
        }

        SessionService.setPersonalInfo(personalInformation);
        return { type: registrationConstants.GET_STARTED_INFORMATION_REQUEST, personalInformation };
    }

    function failure(errorString) {
        return { type: registrationConstants.GET_STARTED_INFORMATION_FAILURE, errorString };
    }
}

function handlePersonalInformationRequest(personalInformation) {
    return dispatch => {
        if (personalInformation.fromProfileInfo) {
            dispatch({ type: registrationConstants.PERSONAL_INFORMATION_REQUEST, personalInformation });
            history.push("/SignUpVerifyIdentity");
        }
        else {
            workflowService.nextStep(dispatch, request, failure, personalInformation);
        }
    };

    function request(personalInformation) {
        SessionService.setPersonalInfo(personalInformation);
        return { type: registrationConstants.PERSONAL_INFORMATION_REQUEST, personalInformation };
    }

    function failure(errorString) {
        return { type: registrationConstants.PERSONAL_INFORMATION_FAILURE, errorString };
    }
}

function handlePersonalInformationBackRequest() {
    return dispatch => {
        workflowService.previousStep(dispatch, request, failure);
    };

    function request() {
        return { type: registrationConstants.PERSONAL_INFORMATION_BACK_REQUEST };
    }

    function failure(errorString) {
        return { type: registrationConstants.PERSONAL_INFORMATION_BACK_FAILURE, errorString };
    }
}

function handleFinancialInformationRequest(financialInformation) {
    return dispatch => {
        workflowService.nextStep(dispatch, request, failure, financialInformation);
    };

    function request(financialInformation) {
        //SessionService.setFinancialInfo(financialInformation);
        return { type: registrationConstants.FINANCIAL_INFORMATION_REQUEST, financialInformation };
    }

    function failure(errorString) {
        return { type: registrationConstants.FINANCIAL_INFORMATION_FAILURE, errorString };
    }
}
function handleFinancialInformationNextRequest() {
    return dispatch => {
        workflowService.nextStep(dispatch, request, failure, null);
    };
    function request() {  
        return { type: registrationConstants.FINANCIAL_INFORMATION_REQUEST };
    }
    function failure(errorString) {
        return { type: registrationConstants.FINANCIAL_INFORMATION_FAILURE, errorString };
    }
}


function handleFinancialInformationBackRequest() {
    return dispatch => {
        workflowService.previousStep(dispatch, request, failure);
    };

    function request() {
        return { type: registrationConstants.FINANCIAL_INFORMATION_BACK_REQUEST };
    }

    function failure(errorString) {
        return { type: registrationConstants.FINANCIAL_INFORMATION_BACK_FAILURE, errorString };
    }
}

function handleIdTypeAndNumberRequest(idTypeAndNumber) {
    return dispatch => {
        try {
            dispatch(registrationResponse({
                userHash: "",
                email: "",
                mobileNumber: ""
            }));
            dispatch(request(idTypeAndNumber));

            if (idTypeAndNumber.existingCustomer) {
                var userHashRequest = {
                    "DateOfBirth": idTypeAndNumber.dateOfBirth,
                    "SSN": idTypeAndNumber.idNumber
                };

                registrationService.getUserHash(userHashRequest).then((userHashResponse) => {
                    registrationService.getExistingCustomerRegistration(userHashResponse.data).then((userData) => {
                        if (userData.data.isHashInUse) {
                            dispatch({ type: userConstants.USER_HASH_IN_USE });
                            history.push("/LogInMain");
                        } else {
                            SessionService.setPersonalInfo({...userData.data, nationalIdNumber : idTypeAndNumber.idNumber})
                            workflowService.nextStep(dispatch, registrationResponse, failure, userData.data);
                        }
                    })
                }); 

            } else if (idTypeAndNumber.confirmationSummaryScreen) {
                history.push("/SignUpConfirmationSummary");
            }
            else {
                workflowService.startWorkflow(workflowConstants.APPLICATION_RECEIVED_WORKFLOW, dispatch, request, failure, idTypeAndNumber);               
            }
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function request(idTypeAndNumber) {
        return {
            type: registrationConstants.IDTYPE_AND_NUMBER_REQUEST, idTypeAndNumber};
    }

    function registrationResponse(registrationInfo) {
        return {
            type: registrationConstants.IDTYPE_AND_NUMBER_SUCCESS, registrationInfo
        };
    }

    function failure(errorString) {
        return { type: registrationConstants.IDTYPE_AND_NUMBER_FAILURE, errorString };
    }
}

function guestPaymentRegistration(userHash) {
    return dispatch => {
        try {
            dispatch(request(userHash));

            registrationService.getExistingCustomerRegistration(userHash).then((userData) => {
                SessionService.setPersonalInfo({ ...userData.data });
                workflowService.startWorkflow(workflowConstants.GUEST_PAYMENT_REGISTRATION, dispatch, success, failure, userData.data);
            });
        }
        catch (errorString) {
            dispatch(failure(errorString));
        }
    }

    function request(userHash) {
        return { type: registrationConstants.GUEST_PAYMENT_REGISTRATION_REQUEST, userHash };
    }

    function success(userData) {
        return { type: registrationConstants.GUEST_PAYMENT_REGISTRATION_SUCCESS, userData };
    }

    function failure(errorString) {
        return { type: registrationConstants.GUEST_PAYMENT_REGISTRATION_FAILURE, errorString };
    }
}

function handleConfirmationSummaryRequest(passwords) {
    return dispatch => {
        try {
            history.push("/SignUpEmailValidation");
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function failure(errorString) {
        return { type: registrationConstants.CONFIRMATION_SUMMARY_ERROR, errorString };
    }
}

function handleNavigationToPersonalDataScreen() {
    return dispatch => {
        try {
            dispatch(handleConfirmationSummaryNavigationRequest());

            history.push("/ProfileInfo");
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function failure(errorString) {
        return { type: registrationConstants.CONFIRMATION_SUMMARY_ERROR, errorString };
    }

    function handleConfirmationSummaryNavigationRequest() {
        return { type: registrationConstants.CONFIRMATION_SUMMARY_NAVIGATION_REQUEST};
    }
}

function handleNavigationToIDScreen() {
    return dispatch => {
        try {
            dispatch(handleConfirmationSummaryNavigationRequest());

            history.push("/SignUpVerifyIdentity");
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function failure(errorString) {
        return { type: registrationConstants.CONFIRMATION_SUMMARY_ERROR, errorString };
    }
    function handleConfirmationSummaryNavigationRequest() {
        return { type: registrationConstants.CONFIRMATION_SUMMARY_NAVIGATION_REQUEST };
    }
}

function handleNavigationToPasswordScreen() {
    return dispatch => {
        try {
            dispatch(handleConfirmationSummaryNavigationRequest());

            history.push("/SignUpCreatePassword");
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function failure(errorString) {
        return { type: registrationConstants.CONFIRMATION_SUMMARY_ERROR, errorString };
    }

    function handleConfirmationSummaryNavigationRequest() {
        return { type: registrationConstants.CONFIRMATION_SUMMARY_NAVIGATION_REQUEST };
    }
}

function handleSendEmailCodeRequest(emailConfirmation, passwords) {

    let emailConfirmationStorage = JSON.parse(sessionStorage.getItem("NewLeadUser"));
    return dispatch => {

        try {
            const MfaRequest = {
                "IssueReason": "ValidateUserInfo",
                "DeliveryMethod": 0, 
                "TargetAddress": emailConfirmationStorage && emailConfirmationStorage.email ? emailConfirmationStorage.email :  emailConfirmation.codeToEmail
            };
            //send the request over to redux before calling the user hash service
            dispatch(request(emailConfirmation, passwords));

            if (MfaRequest.TargetAddress == null &&
                workflowService.getCurrentWorkflowStepData().workflowId === workflowConstants.EXISTING_CUSTOMER_REGISTRATION_WORKFLOW) {
                dispatch(emptyEmail());
                history.push("/SignUpEmailValidation");
            } else {
                registrationService.sendVerificationCode(MfaRequest).then(
                    response => {
                        //todo: look at the user data that is comig back, specifically the messageId to check if the login was really a success
                        if (response.httpResponseCode !== 200) {
                            dispatch(failure(response.message));
                        }
                        else {
                            dispatch(sendemailcodeResponse(response.data.tokenId));

                            history.push("/SignUpEmailValidation");
                        }
                    },
                    error => {
                        dispatch(failure(error));
                    }
                );
            }
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function request(emailConfirmation, passwords) {
        return {
            type: registrationConstants.SEND_EMAIL_CODE_REQUEST, emailConfirmation, passwords
        };
    }

    function sendemailcodeResponse(tokenId) {
        return {
            type: registrationConstants.SEND_EMAIL_CODE_RESPONSE, tokenId
        };
    }
    function failure(errorString) {
        return { type: registrationConstants.SEND_EMAIL_CODE_ERROR, errorString };
    }
    function emptyEmail() {
        return { type: registrationConstants.SEND_EMPTY_EMAIL_ERROR };
    }
}

function handleReSendEmailCodeRequest(codeToEmail) {
    return dispatch => {
        try {
            const MfaRequest = {
                "IssueReason": "ValidateUserInfo",
                "DeliveryMethod": 0, 
                "TargetAddress": codeToEmail
            };
            //send the request over to redux before calling the user hash service
            dispatch(request(codeToEmail));
            registrationService.sendVerificationCode(MfaRequest).then(
                response => {
                        //todo: look at the user data that is comig back, specifically the messageId to check if the login was really a success
                        if (response.httpResponseCode !== 200) {
                            dispatch(failure(response.message));
                        }
                        else {
                            dispatch(sendemailcodeResponse(response.data.tokenId));                          
                        }
                    },
                    error => {
                        dispatch(failure(error));
                    }
                );
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };
    function request(codeToEmail) {
        return {
            type: registrationConstants.RE_SEND_EMAIL_CODE_REQUEST, codeToEmail
        };
    }

    function sendemailcodeResponse(tokenId) {
        return {
            type: registrationConstants.RE_SEND_EMAIL_CODE_RESPONSE, tokenId
        };
    }
    function failure(errorString) {
        return { type: registrationConstants.RE_SEND_EMAIL_CODE_ERROR, errorString };
    }
}

function handleEmailValidationResponse(emailvalidation, profile, saveDevice) {
    let newLeadUser = JSON.parse(sessionStorage.getItem("NewLeadUser"));
    return dispatch => {
        try {

            dispatch(setBusyState(true));
            const mfaAuthenticationRequest = {
                "TokenId": emailvalidation.tokenId,
                "CodeParts": [emailvalidation.confirmationCodeFirstPart, emailvalidation.confirmationCodeSecondPart],
                "DeviceId": "",
                "Reason": "ValidateUserInfo"
            }

            registrationService.verifyCode(mfaAuthenticationRequest).then(
                response => {
                    //todo: look at the user data that is comig back, specifically the messageId to check if the login was really a success
                    if (response.httpResponseCode !== 200 || response.status > 0) {
                        dispatch(failure(response.message));
                    }
                    else {
                        
                        dispatch(emailVaidationResponse(response))
                        //now that the token has been validated, we send the data to the profile service
                        //for creating the profile
                        dispatch(profileCreateRequest);
                        profile.tokenId = emailvalidation.tokenId;
                        profile.reason = "ValidateUserInfo"; 
                        profile.deviceRegistration = {
                            deviceType:0, 
                            deviceInfo: navigator.userAgent, 
                            deviceId: ServiceUtil.getDeviceId()
                        };

                        let personalInfo = SessionService.getPersonalInfo();

                         // incorporate leadID here
                        if (newLeadUser && newLeadUser.leadId) {
                            profile.firstName = personalInfo.firstName;
                            profile.lastName = personalInfo.lastName;
                            profile.userHash = personalInfo.userHash;
                            profile.Email = personalInfo.email;
                            profile.phoneNumber = personalInfo.mobileNumber;
                            profile.leadId = newLeadUser.leadId;
                            profile.SelectedLanguage = userService.getUserLanguage();
                        } else {
                            if (personalInfo) {
                                if (personalInfo.socialSecurityNumber) {
                                    profile.nationalIdNumber = personalInfo.socialSecurityNumber;
                                } else if(personalInfo.nationalIdNumber){
                                    profile.nationalIdNumber = personalInfo.nationalIdNumber;
                                }
                                else {
                                    profile.nationalIdNumber = personalInfo.individualTaxIdentificationNumber;
                                }
                            }
                            else {
                                profile.nationalIdNumber = profile.nationalIdNumber;
                            }
                        }

                        if(newLeadUser) {
                            registrationService.CreateProfileByLeadId(profile).then(response => {
                                if (response.httpResponseCode !== 200 || response.status !== 0) {
                                    dispatch(profileCreateError(response.message));
                                } else {
                                    ServiceUtil.setDeviceId(response.data.deviceId, saveDevice);
                                    userService.loginFromRegistration(profile.Email, profile.Password, mfaAuthenticationRequest).then(user => {
                                        if (user.status <= 1 && user.data.messageId === 1){
                                            dispatch(profileCreateResponse(response));
                                            SessionService.clearSession();
                                            sessionStorage.removeItem("NewLoanUser");                                  
                                            sessionStorage.setItem("user", JSON.stringify(user.data));
                                            dispatch(loginSuccess(user));
                                            workflowService.nextStep(dispatch, registrationLoginSuccess, failure,user);                                           
                                        }else{
                                            dispatch(failure(user.message))
                                        }
                                    }).catch(err => dispatch(failure(err)))
                                    
                                }
                            })
                        } else {
                            registrationService.CreateProfile(profile).then(
                                response => {
                                    //todo: look at the user data that is comig back, specifically the messageId to check if the login was really a success
                                    if (response.httpResponseCode !== 200 || response.status !== 0) {
                                        dispatch(profileCreateError(response.message));
                                    }
                                    else {
                                        ServiceUtil.setDeviceId(response.data.deviceId, saveDevice);
                                        userService.loginFromRegistration(profile.Email, profile.Password, mfaAuthenticationRequest).then(user => {
                                            if (user.status <= 1 && user.data.messageId === 1) {
                                                dispatch(profileCreateResponse(response));

                                                SessionService.clearSession();

                                                sessionStorage.removeItem("loanAmount");
                                                sessionStorage.removeItem("NewLoanUser");
                                                sessionStorage.setItem("user", JSON.stringify(user.data));
                                                dispatch(loginSuccess(user));
                                                workflowService.nextStep(dispatch, registrationLoginSuccess, failure, user); // next step :My Account

                                            } else {
                                                dispatch(failure(user.message))
                                            }
                                        }).catch(err => {
                                            dispatch(failure(err))
                                        });
                                    }
                                },
                                error => {
                                    dispatch(profileCreateError(metadataService.getMessage("CouldNotCreateAccount")));
                                }
                            );
                        }
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function emailVaidationResponse(emailCodeIsValid) {
        return {
            type: registrationConstants.EMAIL_CODE_VALIDATION_RESPONSE, emailCodeIsValid
        };
    }
    function setBusyState(busyValue){
        return {
            type:registrationConstants.SET_BUSY, isBusy: busyValue
        }
    }
    function failure(errorString) {
        return { type: registrationConstants.EMAIL_CODE_VALIDATION_ERROR, errorString };
    }

    function profileCreateRequest() {
        return {
            type: registrationConstants.PROFILE_CREATE_REQUEST
        };
    }

    function profileCreateResponse() {
        return {
            type: registrationConstants.PROFILE_CREATE_RESPONSE
        };
    }

    function profileCreateError(errorString) {
        return { type: registrationConstants.PROFILE_CREATE_ERROR, errorString: metadataService.getMessage("CouldNotCreateAccount") };
    }
    function registrationLoginSuccess(user){
        return { type: registrationConstants.REGISTRATION_LOGIN_SUCCESS, user };
    }
    function loginSuccess(user) {
        
        return { type: userConstants.LOGIN_SUCCESS, user };
      }
    
}

function handleTextOptInRequest(textOptInRequest) {
    return dispatch => {
        try {
            const MfaRequest = {
                "IssueReason": "ValidateUserInfo",
                "DeliveryMethod": 1,
                "TargetAddress": textOptInRequest.targetAddress
            };

            //send the request over to redux before calling the user hash service
            dispatch(request(textOptInRequest));

            registrationService.sendVerificationCode(MfaRequest).then(
                response => {
                    //todo: look at the user data that is comig back, specifically the messageId to check if the login was really a success

                    if (response.httpResponseCode !== 200) {
                        dispatch(failure(response.message));
                    }
                    else {
                        dispatch(sendPhonecodeResponse(response.data.tokenId));
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function request(textOptInRequest) {
        return {
            type: registrationConstants.TEXT_OPTIN_REQUEST, textOptInRequest
        };
    }

    function sendPhonecodeResponse(tokenId) {
        return {
            type: registrationConstants.TEXT_OPTIN_RESPONSE, tokenId
        };
    }
    function failure(errorString) {
        return { type: registrationConstants.TEXT_OPTIN_FAILURE, errorString };
    }
}

function handleConfirmOptIn(mfaToken, email){
    return (dispatch, getState) => {
        registrationService.sendConfirmMobileOptIn(mfaToken, email, true)
        .then(
            response => {
                if(response.status <= 1){
                    //Success. 
                    dispatch(confirmPhoneCodeResponse());
                    const user = getState().registration.userLogged;
                    sessionStorage.setItem("user", JSON.stringify(user.data));
                    workflowService.nextStep(dispatch, loginSuccess, error,user);                   
                }
                else{
                    //failure. 
                    dispatch(error(response.message));
                }
            }
        )
        
    };
    function error(message){
        return {
            type: registrationConstants.CONFIRM_PHONE_CODE_ERROR, 
            message: message
        }
    }
    function confirmPhoneCodeResponse(mfaToken) {
        return {
            type: registrationConstants.CONFIRM_PHONE_CODE_RESPONSE, 
            mfaToken : mfaToken
        };
    }
    function loginSuccess(user){
        return { type: userConstants.LOGIN_SUCCESS, user };
    }
}

function handleConfirmPhoneCodeRequest(codeToPhonevalidation) {
    return dispatch => {
        try {
            const mfaAuthenticationRequest = {
                "TokenId": codeToPhonevalidation.tokenId,
                "CodeParts": [codeToPhonevalidation.confirmationCodeFirstPart, codeToPhonevalidation.confirmationCodeSecondPart],
                "DeviceId": "",
                "Reason": "ValidateUserInfo"
            }

            registrationService.verifyCode(mfaAuthenticationRequest).then(
                response => {
                    //todo: look at the user data that is comming back, specifically the messageId to check if the login was really a success

                    if (response.httpResponseCode !== 200 || response.status > 0) {
                        dispatch(failure(response.message));
                    }
                    else {

                        dispatch(confirmPhoneCodeResponse())
                        history.push("/SignUpLogIn");
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function confirmPhoneCodeResponse() {
        return {
            type: registrationConstants.CONFIRM_PHONE_CODE_RESPONSE
        };
    }

    function failure(errorString) {
        return { type: registrationConstants.EMAIL_CODE_VALIDATION_ERROR, errorString };
    }
}

function handleTextOptOutRequest() {
    return (dispatch,getState) => {
        try {
            dispatch(sendtextOptOutRequest());
            const user = getState().registration.userLogged;
            sessionStorage.setItem("user", JSON.stringify(user.data));
            workflowService.nextStep(dispatch, loginSuccess, error,user);           
        } catch (errorString) {
            dispatch(failure(errorString));
        }
    };

    function sendtextOptOutRequest() {
        return {
            type: registrationConstants.TEXT_OPTOUT_REQUEST
        };
    }
    function failure(errorString) {
        return { type: registrationConstants.TEXT_OPTOUT_ERROR, errorString };
    }
    function loginSuccess(user){
        return { type: userConstants.LOGIN_SUCCESS, user };
    }
}

function handleWelcomeNextRequest(leadId, email, phone) {
    return dispatch => {

        var leadInfo = {
            leadId: leadId,
            email: email,
            mobileNumber: phone
        };

        workflowService.nextStep(dispatch, welcomeNextRequest, failure, leadInfo);
    };

    function welcomeNextRequest(leadInfo) {
        return {
            type: registrationConstants.WELCOME_NEXT_REQUEST,
            leadId: leadInfo.leadId,
            email: leadInfo.email,
            mobileNumber: leadInfo.mobileNumber
        };
    }

    function failure(errorString) {
        return { type: registrationConstants.WELCOME_NEXT_FAILURE, errorString };
    }
}

function handleInvalidToken() {
    return dispatch => {
        history.push("/LogInMain");
    };
}

function handleSetMarketing(marketingCookies) {

    return dispatch => {
        dispatch(setMarketing());
    }

    function setMarketing() {
        return { type: registrationConstants.SET_MARKETING_COOKIES,  marketingCookies};
    }

}

function populateRegistrationProps(d) {
    return { type: registrationConstants.POPULATE_REGISTRATION_DATA, data: d}
}

function handleSignUpEmailValidationBackRequest() {
    return dispatch => {
        workflowService.previousStep(dispatch, request, failure);
    };

    function request() {
        return { type: registrationConstants.SIGNUP_EMAIL_VALIDATION_BACK_REQUEST };
    }

    function failure(errorString) {
        return { type: registrationConstants.SIGNUP_EMAIL_VALIDATION_BACK_FAILURE, errorString };
    }
}